"use strict";
class ScrollPositionHandler {
    constructor() {
        // 要素の配列を保持
        this.elements = [];
        // デバウンス用のタイムアウトID
        this.timeoutId = null;
        // スクロールハンドラーをバインド
        this.handleScroll = this.handleScroll.bind(this);
        // スクロールイベントの登録
        window.addEventListener("scroll", this.debouncedHandleScroll.bind(this));
        window.addEventListener("resize", this.debouncedHandleScroll.bind(this));
    }
    // スクロール位置に基づいて位置を計算
    calculatePosition(element) {
        const windowHeight = window.innerHeight;
        const rect = element.getBoundingClientRect();
        // 要素の上端位置
        const elementTop = rect.top;
        // 画面の中心位置
        const screenCenter = windowHeight / 2;
        // 要素が画面下部より下にある場合は0
        if (elementTop >= windowHeight) {
            return 0;
        }
        // 要素の上端が画面中央に達した場合は1
        if (elementTop <= screenCenter) {
            return 1;
        }
        // 画面下部（0）から画面中央（1）までの進捗を計算
        const totalDistance = windowHeight - screenCenter; // 画面下部から中央までの距離
        const currentDistance = windowHeight - elementTop; // 現在の移動距離
        return Math.max(0, Math.min(1, currentDistance / totalDistance));
    }
    // スクロールハンドラー
    handleScroll() {
        this.elements.forEach((element, index) => {
            const position = this.calculatePosition(element);
            const roundedPosition = position.toFixed(2);
            console.log(roundedPosition);
            element.setAttribute("data-position", roundedPosition);
            if (index === 0) {
                //console.log(-0.2 * Number(roundedPosition) + 1);
            }
            //const transform = 1 - Number(roundedPosition);
            const transform = 0.2 * Number(roundedPosition) + 0.8;
            const opacity = Number(roundedPosition);
            element.style.scale = String(transform);
            element.style.opacity = String(opacity);
        });
    }
    // デバウンス処理
    debouncedHandleScroll() {
        if (this.timeoutId) {
            clearTimeout(this.timeoutId);
        }
        this.timeoutId = setTimeout(() => {
            this.handleScroll();
        }, 10);
    }
    addElements(selector) {
        const elements = document.querySelectorAll(selector);
        this.elements = [...elements].map((element) => element);
        this.handleScroll();
        return this;
    }
}
const scrollHandler = new ScrollPositionHandler();
scrollHandler.addElements(".departmentItem");
